import { produce } from 'immer';
import { breakdownModules } from '.';

export const actions = (set, get) => ({
    setSelectedBreakdownTab: (selectedBreakdownTab) =>
        set(
            produce((state) => {
                const selectedModule = get().selectedModule;
                const moduleState = state[selectedModule];

                if (!Object.keys(breakdownModules).includes(selectedModule)) return;

                moduleState.breakdowns.selectedBreakdownTab = selectedBreakdownTab;
            }),
            false,
            'setSelectedBreakdownTab'
        ),
    setBreakdownTabs: (newTabs, pathname) =>
        set(
            produce((state) => {
                const selectedModule = get().selectedModule;
                const moduleState = state[selectedModule];

                if (
                    !Object.keys(breakdownModules).includes(selectedModule) ||
                    !moduleState?.breakdowns?.tabsByRoute
                ) {
                    return;
                }

                newTabs.forEach((item) => {
                    Object.keys(item).forEach((key) => {
                        // eslint-disable-next-line no-prototype-builtins
                        if (moduleState.breakdowns.tabsByRoute[pathname].hasOwnProperty(key)) {
                            moduleState.breakdowns.tabsByRoute[pathname][key] = {
                                ...moduleState.breakdowns.tabsByRoute[pathname][key],
                                ...item[key]
                            };
                        } else {
                            throw new Error(`Key "${key}" doesn't exist in breakdownTabs.`);
                        }
                    });
                });
            }),
            false,
            `setBreakdownTabs`
        ),
    setToggleShouldShowAdditionalInfo: (pathname) => {
        const selectedModule = get().selectedModule;
        const moduleState = get()?.[selectedModule];
        const selectedBreakdownTab = moduleState?.breakdowns.selectedBreakdownTab;
        const prevShouldShowAdditionlInfo =
            moduleState?.breakdowns?.tabsByRoute[pathname][selectedBreakdownTab]
                ?.shouldShowAdditionalInfo;

        get().setBreakdownTabs(
            [
                {
                    [selectedBreakdownTab]: {
                        shouldShowAdditionalInfo: !prevShouldShowAdditionlInfo
                    }
                }
            ],
            pathname
        );
    },
    setSelectedBreakdownOffice: (office) =>
        set(
            produce((state) => {
                const selectedModule = get().selectedModule;
                const moduleState = state[selectedModule];

                if (!Object.keys(breakdownModules).includes(selectedModule)) return;

                moduleState.breakdowns.selectedBreakdownOffice = office;
            }),
            false,
            'setSelectedBreakdownOffice'
        ),
    resetBreakdowns: () =>
        set(
            produce((state) => {
                const selectedModule = get().selectedModule;
                const moduleState = state[selectedModule];

                if (!Object.keys(breakdownModules).includes(selectedModule)) return;

                moduleState.breakdowns = breakdownModules[selectedModule].initialState;
            }),
            false,
            'resetBreakdowns'
        )
});
